import React from 'react';
import parse from 'html-react-parser';
import { handleBodyScrollHidden } from '../../../utils/helpers';
import Modal from '../../2_Molecules/Modal/Modal';

interface FiftyFiftyModalProps {
  title?: string;
  description?: string;
  imageSrc?: string;
  imageAlt?: string;
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

const FiftyFiftyModal: React.FC<FiftyFiftyModalProps> = ({
  title = '',
  description = '',
  imageSrc = '',
  imageAlt = '',
  isOpen,
  setIsModalOpen,
}) => {

  return (
    <Modal
      className="mz-modal--non-sticky-top mz-modal-fifty-fifty"
      isOpen={isOpen}
      onClose={() => {
        setIsModalOpen(false);
        handleBodyScrollHidden(false);
      }}
      children={(
        <div className="mz-5050">
          <div className="mz-container unconstrained mz-5050-container full-width no-gutter-between-cols">
            <div className="mz-5050-left mz-5050-content">
              <div className="mz-image-nolazy mz-image">
                <img src={imageSrc} alt={imageAlt} />
              </div>
            </div>
            <div className="mz-5050-right mz-5050-content">
              <div className="mz-5050-text-wrapper text--left">
                <h3 className="mz-5050__title">{title}</h3>
                <div className="mz-5050__paragraph paragraph">{parse(description)}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default FiftyFiftyModal;
